import { DataBox } from './DataBox'
import { baseTrailerModel } from '../trailerModel'
import { PageHeader } from './PageHeader'
import { AddTrailerModal } from './addTrailerModal'
import { EditTrailerModal } from './editTrailerModal'

export function BaseTrailer() {
    const { addCarVisible, editCarVisible } = baseTrailerModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddTrailerModal />}
            {editCarVisible && <EditTrailerModal />}
        </>
    )
}
